import { cn } from "../../../lib/utils.js";
import { Input } from "../../ui/input.tsx";

import FormButton from "../FormButton.tsx";
import { ResizableTextarea } from "../../ui/resizable-textarea.tsx";

import useStyles from "../../../Hooks/useStyles.ts";

import { useFormEditorContext } from "../../../Contexts/FormEditorContext";
import React from "react";
import clsx from "clsx";

export default function Calendly() {
    const { device, theme, fields, setFields, setEditorField, editorField } =
        useFormEditorContext();
    const [error, setError] = React.useState<string | null>(null);
    const [calendlyEventUrl, setCalendlyEventUrl] = React.useState<
        string | null
    >(editorField?.properties?.calendly_event_url || "");
    const { getStyles } = useStyles();

    const getDeviceStyle = () => {
        if (device === "mobile") {
            return "h-[36px]";
        }
        return "h-[40px]";
    };

    const deviceStyle = getDeviceStyle();

    const updateField = (fieldId, key, subkey: string | null = null, value) => {
        setFields((prevFields) => {
            const updatedFields = prevFields.map((field) => {
                if (field.id === fieldId) {
                    if (subkey) {
                        return {
                            ...field,
                            [key]: {
                                ...field[key],
                                [subkey]: value,
                            },
                        };
                    } else {
                        return {
                            ...field,
                            [key]: value,
                        };
                    }
                }
                return field;
            });
            return updatedFields;
        });

        setEditorField((prev) => {
            if (subkey) {
                return {
                    ...prev,
                    [key]: {
                        ...prev[key],
                        [subkey]: value,
                    },
                };
            } else {
                return {
                    ...prev,
                    [key]: value,
                };
            }
        });

        //setChanged(true);
    };

    const isValidCalendlyUrl = (url: string) =>
        /^https:\/\/calendly\.com\/[a-zA-Z0-9_-]+(\/[a-zA-Z0-9_-]+)?(\?.*)?$/.test(
            url,
        );

    const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setCalendlyEventUrl(value);
    };

    const handleBlur = () => {
        if (calendlyEventUrl) {
            if (isValidCalendlyUrl(calendlyEventUrl)) {
                setError(null);
                updateField(
                    editorField?.id,
                    "properties",
                    "calendly_event_url",
                    calendlyEventUrl,
                );
            } else {
                setError(
                    "Please enter a valid Calendly event URL (e.g., https://calendly.com/your-username/event-name)",
                );
            }
        } else {
            updateField(
                editorField?.id,
                "properties",
                "calendly_event_url",
                calendlyEventUrl,
            );
        }
    };

    console.log("Calendly event URL:", calendlyEventUrl);
    console.log("Error state:", error);
    console.log(
        "Editor field properties:",
        editorField?.properties?.calendly_event_url,
    );

    return (
        <div className={clsx("flex flex-col gap-0 w-full max-w-[606px]")}>
            <ResizableTextarea
                placeholder="Add question title"
                value={editorField?.title || ""}
                onChange={(value) =>
                    updateField(editorField?.id, "title", null, value)
                }
                style={{
                    color: theme?.text_color,
                    fontSize: getStyles("h2", theme?.text_size, device)
                        .fontSize,
                    fontWeight: getStyles("h2", theme?.text_size, device)
                        .fontWeight,
                    fontFamily: `${theme?.font_family?.family}, ${theme?.font_family?.category}`,
                }}
            />
            <ResizableTextarea
                placeholder="Add question description (Optional)"
                value={editorField?.properties?.description || ""}
                onChange={(value) =>
                    updateField(
                        editorField?.id,
                        "properties",
                        "description",
                        value,
                    )
                }
                style={{
                    color: theme?.text_color,
                    fontSize: getStyles("h4", theme?.text_size, device)
                        .fontSize,
                    fontWeight: getStyles("h4", theme?.text_size, device)
                        .fontWeight,
                    fontFamily: `${theme?.font_family?.family}, ${theme?.font_family?.category}`,
                }}
                className="mt-2"
            />
            <Input
                value={calendlyEventUrl || ""}
                onChange={handleUrlChange}
                placeholder="Enter a event URL"
                style={{
                    color: theme?.answer_text_color,
                    fontSize: getStyles("h2", theme?.text_size, device)
                        .fontSize,
                    fontWeight: getStyles("h2", theme?.text_size, device)
                        .fontWeight,
                    fontFamily: `${theme?.font_family?.family}, ${theme?.font_family?.category}`,
                }}
                className={cn(
                    `p-0 mt-4 border-x-0 border-t-0 rounded-none border-b border-[#B3B9C4] text-left bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 outline-none overflow-hidden`,
                    deviceStyle,
                )}
                type="url"
                pattern="https://calendly.com/*"
                onBlur={handleBlur}
            />
            <p
                style={{
                    color: theme?.text_color,
                }}
                className="mt-4 text-xs text-left"
            >
                Your respondents will see the Calendly booking view directly.
                They won’t see this screen.
            </p>
            {error && (
                <p className="mt-2 text-xs text-left text-[red]">{error}</p>
            )}
            <FormButton className="mt-3" />
        </div>
    );
}
